<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <h1 class="text-title-underline">{{ t('counselingReports.title') }}一覧</h1>
        <div class="pt-3 px-3 md:pt-4 md:px-4">
          <div class="flex justify-end">
            <button @click="toggleFilter"
              :class="showMyReports ? 'border border-orange-600 hover:bg-orange-600 bg-orange-600 text-white' : 'border border-orange-600 hover:bg-gray-50 bg-white text-orange-600'"
              class=" flex justify-center items-center w-44 py-1 rounded mb-2 mr-2">
              <base-svg-icon class="min-w-[1.3rem] mr-1" :path="mdiFilter" />
              <div>自分のレポート</div>
            </button>
            <button @click="createReport"
              class="text-mentalncText flex justify-center items-center w-28 py-1 bg-white border border-mentalncText hover:bg-gray-50 rounded mb-2 mr-2">
              <base-svg-icon class="min-w-[1.3rem] mr-1" :path="mdiNoteEdit" />
              <div>新規作成</div>
            </button>
            <button @click="store.state.counselingReport.searchDialogVisible = true"
              class="text-blue-600 flex bg-white justify-center items-center w-28 py-1 border border-blue-600 hover:bg-gray-50 rounded mb-2">
              <base-svg-icon class="min-w-[1.3rem] mr-1" :path="mdiFileSearch" />
              <div>検索</div>
            </button>
          </div>
          <template v-if="Array.isArray(filteredReports) && filteredReports.length">
            <ul>
              <li v-for="report in pagedList" :key="report.id" class="pb-1 md:pb-2">
                <router-link :to="`/counseling-reports/${report.id}`">
                  <div class="shadow-md p-4 hover:bg-gray-50 border border-mentalncText bg-white">
                    <div class="flex items-center flex-wrap">
                      <div class="flex-grow flex flex-wrap items-center">
                        <p class="text-base md:text-xl mr-2">{{ report.counseling_client?.nick_name }} さん</p>
                        <p class="text-sm md:text-base mr-2">{{ report.counseling_client?.age }}</p>
                        <p class="text-sm md:text-base mr-2">{{ report.counseling_client?.gender }}</p>
                        <p class="text-sm md:text-base mr-2">{{ report.counseling_client?.residence }}在住</p>
                      </div>
                      <div
                        class="w-full md:w-auto md:ml-auto mt-2 md:mt-0 text-right md:text-left flex items-center justify-start md:justify-end">
                        <p class="text-xs md:text-base mr-1 text-orange-700">カウンセラー：{{ report.user?.name }}</p>
                        <template v-if="report.is_hidden">
                          <p class="text-xs md:text-sm bg-gray-500 px-2 rounded-full text-white mr-1">非公開中</p>
                        </template>
                        <template v-if="report.user_id === userId">
                          <p
                            class="text-xs md:text-sm bg-orange-500 px-1 rounded-full text-white flex justify-center items-center">
                            <base-svg-icon class="w-5 md:w-5" :path="mdiAccount" />
                          </p>
                        </template>
                      </div>
                    </div>
                    <div class="p-1">
                      <div class="text-xs md:text-base grid grid-cols-6 md:grid-cols-12 mb-1">
                        <p class="col-span-2 md:col-span-2 border-r-4 border-gray-200 ml-0 md:ml-5">実施日</p>
                        <p class="col-span-4 md:col-span-10 ml-1">{{
                          dayjs(report.implementation_date).format('YYYY年MM月DD日') }} </p>
                      </div>
                      <div class="text-xs md:text-base grid grid-cols-6 md:grid-cols-12 mb-1">
                        <p class="col-span-2 md:col-span-2 truncate border-r-4 border-gray-200 ml-0 md:ml-5">セッションテーマ</p>
                        <div
                          class="col-span-4 md:col-span-10 ml-1 overflow-hidden truncate whitespace-nowrap text-ellipsis">
                          <template
                            v-if="report.counseling_session_themes && report.counseling_session_themes.length > 0">
                            <span v-for="(theme, index) in report.counseling_session_themes" :key="index"
                              :style="{ color: theme.theme_color }" class="whitespace-nowrap">
                              {{ theme.session_theme_name }}<span
                                v-if="index < report.counseling_session_themes.length - 1">、</span>
                            </span>
                          </template>
                        </div>
                      </div>
                      <div class="text-xs md:text-base grid grid-cols-6 md:grid-cols-12">
                        <p class="col-span-2 md:col-span-2 truncate border-r-4 border-gray-200 ml-0 md:ml-5">扱ったノイズ</p>
                        <div
                          class="col-span-4 md:col-span-10 ml-1 overflow-hidden truncate whitespace-nowrap text-ellipsis">
                          <template v-if="report.counseling_mental_noises && report.counseling_mental_noises.length > 0">
                            <span v-for="(noise, index) in report.counseling_mental_noises" :key="index"
                              :style="{ color: noise.theme_color }" class="whitespace-nowrap">
                              {{ noise.mental_noise_name }}<span
                                v-if="index < report.counseling_mental_noises.length - 1">、</span>
                            </span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
            <div class="flex items-center justify-center mt-10">
              <base-pagination v-model:pagedList="pagedList" :originalList="filteredReports" :pageSize="pageSize" />
            </div>
          </template>
          <template v-else>
            カウンセリングレポートが見つかりませんでした。
          </template>
        </div>
      </div>
      <el-dialog v-model="store.state.counselingReport.searchDialogVisible"
        :width="store.state.base.responsive.isMD ? '100%' : '60%'"
        :fullscreen="store.state.base.responsive.isMD ? true : false">
        <h1 class="text-title-underline">{{ t('counselingReports.title') }}検索</h1>
        <CounselingReportSearch />
        <template #footer>
        </template>
      </el-dialog>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, onMounted, computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index'
import { useRouter } from 'vue-router'
import { dayjs } from '@/plugins/dayjs'
import { CounselingReportAttributes } from '@/types/models/counseling-report'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import BasePagination from '@/components/BasePagination.vue'
import CounselingReportSearch from '@/components/CounselingReportSearch.vue'

import { mdiNoteEdit, mdiFileSearch, mdiFilter, mdiAccount } from '@mdi/js'
import BaseSvgIcon from '@/components/BaseSvgIcon.vue'

export default defineComponent({
  components: {
    LayoutsAuth,
    LayoutsAuthWidth,
    BasePagination,
    BaseSvgIcon,
    CounselingReportSearch
  },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const router = useRouter()
    const counselingReports = computed(() => store.state.counselingReport.counselingReports)
    const userId = computed(() => store.state.user.user.id) // 自分のIDを取得
    const pageSize = ref(10)
    const pagedList = ref<CounselingReportAttributes[]>([])
    const filteredReports = ref<CounselingReportAttributes[]>([]) // フィルタリングされたレポート
    const showMyReports = ref(false) // 自分のレポート表示状態

    onMounted(() => {
      store.dispatch('counselingReport/fetchCounselingReports').then(() => {
        filteredReports.value = counselingReports.value // 初期表示は全レポート
      })
      store.dispatch('counselingReport/fetchCounselingClientChangeds')
      store.dispatch('counselingReport/fetchCounselingSessionThemes')
      store.dispatch('counselingReport/fetchCounselingMentalNoises')
    })

    const createReport = () => {
      router.push('/counseling-report-create')
    }

    const toggleFilter = () => {
      if (showMyReports.value) {
        filteredReports.value = counselingReports.value
      } else {
        filteredReports.value = counselingReports.value.filter((report: any) => report.user_id === userId.value)
      }
      showMyReports.value = !showMyReports.value
    }

    watch(counselingReports, (newReports) => {
      if (showMyReports.value) {
        filteredReports.value = newReports.filter((report: any) => report.user_id === userId.value)
      } else {
        filteredReports.value = newReports
      }
    })

    return {
      t,
      dayjs,
      store,
      counselingReports,
      filteredReports,
      pageSize,
      pagedList,
      showMyReports,
      mdiNoteEdit,
      mdiFileSearch,
      mdiFilter,
      mdiAccount,
      createReport,
      toggleFilter,
      userId
    }
  }
})
</script>
